import React from 'react';
import PropTypes from 'prop-types';

export const Toggler = ({ isActive, name, size, className, onClick, ...props }) => {
    return (
        <>
            <input
                type="checkbox"
                name={name}
                className={[`mobile-toggle`, `mobile-toggle-${size}`].join(' ') + (className ? ` ${className}` : '')}
                checked={isActive}
                {...props}
            />
            <label htmlFor={name} onClick={onClick}></label>
        </>
    );
};

Toggler.propTypes = {
    size: PropTypes.oneOf(['sm', 'md']),
    onClick: PropTypes.func,
    isActive: PropTypes.bool,
    name: PropTypes.string.isRequired
};

Toggler.defaultProps = {
    size: 'md',
    onClick: undefined,
    isActive: false,
};

// export const useToggler = ({ defaultState = false, size, className, ...props }) => {
//     const [isActive, setIsActive] = useState(defaultState);

//     const toggler = Toggler({ isActive, size, className, ...props });

//     return { isActive, setIsActive, toggler };
// }